import { useState, useEffect } from 'react';
import './Games.css';
import ShootingStarGame from './ShootingStarGame';
import CloverGame from './CloverGame';
import EnergyGame from './EnergyGame';
import CardGame from './CardGame';
import ReactionGame from './ReactionGame';

const games = [
    { component: ShootingStarGame, name: '별똥별 터치' },
    { component: CloverGame, name: '네잎클로버 찾기' },
    { component: EnergyGame, name: '기운 모으기' },
    { component: CardGame, name: '운세 카드 맞추기' },
    { component: ReactionGame, name: '반응속도 테스트' }
];

export default function RandomGame({ theme = 'default' }) {
    const [GameComponent, setGameComponent] = useState(null);

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * games.length);
        setGameComponent(() => games[randomIndex].component);
    }, []);

    // useEffect(() => {
    //     setGameComponent(() => games[1].component); //인덱싱으로 게임 고정
    // }, []);

    if (!GameComponent) return null;

    return (
        <div className={`game-wrapper ${theme}`}>
            <GameComponent theme={theme} />
        </div>
    );
}

export { ShootingStarGame, CloverGame, EnergyGame, CardGame, ReactionGame };
